import axios from "./axiosConfig";
import { apis } from './params';
import queryString from 'query-string';

export function getOrderChatbotAnalyticsService(params: any) {
    const queryParams = new URLSearchParams();

    if (params.startDate) queryParams.append('start_date', params.startDate);
    if (params.endDate) queryParams.append('end_date', params.endDate);

    const url = `${apis.GET_ORDER_CHATBOT_ANALYTICS}${queryParams ? '?' + queryParams : ''}`;
    return axios({
        "method": "GET",
        "url": url
    });
}

export function getChatbotConversationsService(params: any) {

    const queryParams = new URLSearchParams();

    // Pagination
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());

    // Filters
    if (params.user_id) queryParams.append('user_id', params.user_id);
    if (params.phone) queryParams.append('phone', params.phone);
    if (params.intent) queryParams.append('intent', params.intent);
    if (params.has_issue !== undefined) queryParams.append('has_issue', params.has_issue.toString());
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.search) queryParams.append('search', params.search);
    if (params.search_str) queryParams.append('search_str', params.search_str);

    // Sorting
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);

    const url = `${apis.GET_CHATBOT_CONVERSATIONS}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return axios({
        "method": "GET",
        "url": url
    });
}